<script>
    import List from '../../../components/list.svelte';
    import { format } from 'svelte-i18n';

    let { data = [] } = $props();

    let prefix = 'billingTable';

    let instructs = [
        {key: 'date', title: $format("list.columns.date"), filterable: false},
        {key: 'concept', title: $format("list.columns.concept"), filterable: false},
        {key: 'count', title:$format("list.columns.amount"), filterable: false},
        {key: 'amount', title: $format("list.columns.price"), filterable: false},
    ];
</script>
<style>

</style>
<div class="row">
    <div class="col-12">
        <div class="card">
            <div class="card-body">
                <div class="table-responsive">
                    <List {data} {prefix} {instructs} rowsPerPage={50} />
                </div>
            </div>
        </div>
    </div>
</div>
